<!-- <div class="modal-content"> -->
<!-- <div class="modal-body"> -->
<!-- Manual de orientaçao para contratação de plano odonto Unimed -->
<section>
  <app-manual-orientacao-proposta
    [dadosOperadoraDM]="dadosOperadoraDM"
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
    [tipoProduto]="tipoProduto"></app-manual-orientacao-proposta>
</section>
<!-- Formulário do Beneficiário odonto Unimed-->
<section>
  <app-formulario-beneficiario-proposta
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
    [dadosOperadoraDM]="dadosOperadoraDM"
    [tipoProduto]="tipoProduto"
    [entidadeProposta]="entidadeProposta"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [listaBeneficiariosFormulario]="listaBeneficiariosFormulario"></app-formulario-beneficiario-proposta>
</section>
<!-- Dados Bancários  -->
<section>
  <app-formulario-dados-bancarios-proposta
    [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
    [dadosOperadoraDM]="dadosOperadoraDM"
    [tipoProduto]="tipoProduto"
    [entidadeProposta]="entidadeProposta"
    [razaoSocialEntidade]="razaoSocialEntidade"
    [codigoProposta]="codigoProposta"
    [vigenciaProposta]="vigenciaProposta"
    [nomeTitular]="nomeTitular"
    [tipoPlano]="tipoPlano"
    [tipoRegistroProduto]="tipoRegistroProduto"
    [ansProduto]="ansProduto"
    [acomadacaoPlano]="acomadacaoPlano"
    [dataAssinaturaDadosBancarios]="dataAssinaturaDadosBancarios"
    [horaAssinaturaDadosBancarios]="horaAssinaturaDadosBancarios"
    [totalPlano]="totalPlano"
    [totalPlanoComTaxa]="totalPlanoComTaxa"
    [beneficiarios]="beneficiarios"
    [cpfTitular]="cpfTitular"
    [valorRecebidoPeloBeneficiario]="valorRecebidoPeloBeneficiario"></app-formulario-dados-bancarios-proposta>
  <!-- Assinatura -->
  <!-- <div class="doc-footer border mb-5" style="border-radius: 10px; padding: 0.5rem">
    <p>
      <b>Assinatura do beneficiário titular:</b>
    </p>
    <p>
      Assinatura via área logada pelo beneficiário
      {{ nomeTitular }} em {{ dataAssinaturaDadosBancarios }} às {{ horaAssinaturaDadosBancarios }}, comercialização
      através da corretora {{ nomeCorretora }} e vendedor {{ nomeVendedor }}, conforme Art. 7º da RN 413
    </p>
    <p>
      Data de preenchimento da proposta:
      {{ dataAssinaturaDadosBancarios }}
    </p>
  </div> -->

  <app-assinatura-documento
    [nomeTitular]="nomeTitular"
    [dataAssinatura]="dataAssinaturaDadosBancarios"
    [horaAssinatura]="horaAssinaturaDadosBancarios"
    [nomeCorretora]="nomeCorretora"
    [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
</section>

<section>
  <div class="documento-aditivo-container espacamento-mobile alinhamento-texto-mobile">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
    <h3
      class="titulo text-center bold-preto-700 mb-1"
      style="padding: 0.5rem; background: black; color: #fff; border-radius: 10px">
      <ng-container>PROPOSTA DE ADESÃO UNIMED ODONTO</ng-container>
    </h3>
    <p class="mb-1">
      Pelo presente instrumento, solicito a minha adesão e dos dependentes por mim relacionados, como BENEFICIÁRIO do
      CONTRATO DE PLANO DE SAÚDE ODONTOLÓGICO, firmado em 21/05/2013, entre a administradora de benefícios ADMSERV
      BENEFÍCIOS E SERVIÇOS LTDA de nome fantasia Géia Administradora de Benefícios, registrada na Agência Nacional de
      Saúde Suplementar -ANS, sob o número 416932, inscrita no CNPJ/MF sob o nº 07.867.825/0001-57, com sede à Av.
      Valdemar Ferreira, 463 - Butantã, São Paulo - SP, CEP: 05501-000, doravante denominado ESTIPULANTE e a operadora
      de Planos de Saúde Odontológicos Unimed Saúde e Odonto S/A, registrada na Agência Nacional de Saúde Suplementar –
      ANS sob o número 41.680-1 e no CNPJ/MF sob nº 10.414.182/0001-09, com endereço à R. Alameda Ministro Rocha
      Azevedo, 346 - 4°andar Cerqueira César, São Paulo - SP, 01410-901, denominada CONTRATADA, em razão do vínculo de
      caráter profissional, classista ou setorial que possuo com a Entidade de Classe, denominada ENTIDADE ADERENTE.
    </p>
    <ul>
      <li>
        <p class="m-2">
          1. Para a formalização da presente adesão, o BENEFICIÁRIO declara ter completo conhecimento de todas as
          condições estabelecidas no CONTRATO celebrado entre o ESTIPULANTE E A CONTRATADA, em Maio de 2013, concordando
          com as mesmas e afirmando que não existe qualquer dúvida a respeito do plano de saúde odontológico escolhido.
        </p>
      </li>
      <li>
        <p class="m-2">
          2. Fica o BENEFICIÁRIO ciente de que o prêmio mensal do plano de saúde odontológico contratado,
          independentemente da data de adesão de cada beneficiário, será reajustado anualmente, no mês Junho de cada
          ano.
        </p>
      </li>
      <li>
        <p class="m-2">
          3. O BENEFICIÁRIO declara ter conhecimento de que seu ingresso no presente plano, somente será possível,
          mediante comprovação de seu vínculo associativo com a entidade de classe citada na proposta de adesão. Para
          isso, declara exercer a profissão indicada na proposta de adesão, sob pena de cancelamento da presente
          proposta.
        </p>
      </li>
      <li>
        <p class="m-2">
          4. É obrigação do BENEFICIÁRIO TITULAR, manter atualizadas as informações cadastrais junto à ESTIPULANTE,
          inclusive em relação ao seu vínculo associativo com a entidade de classe e ao seu endereço para
          correspondências. Toda e qualquer correspondência, notificação, cobranças e avisos serão considerados válidos
          e recebidos se remetidos ao endereço indicado pelo BENEFICIÁRIO.
        </p>
      </li>
      <li>
        <p class="m-2">
          5. Novas inclusões de BENEFICIÁRIOS DEPENDENTES deverão ser solicitadas pelo BENEFICIÁRIO TITULAR junto à
          ESTIPULANTE até o dia 15 de cada mês, para que o atendimento assegurado pelo plano de saúde odontológico tenha
          vigência a partir do 1º dia do mês subsequente à inclusão.
        </p>
      </li>
      <li>
        <p class="m-2">
          6. Para solicitar eventuais exclusões de beneficiários dependentes ou o cancelamento da sua adesão, o
          BENEFICIÁRIO TITULAR, compromete-se a comunicar, através dos canais de comunicação disponibilizados pela
          ESTIPULANTE e OPERADORA, em cumprimento à Resolução Normativa editada pela Agência Nacional de Saúde
          Suplementar, RN nº 561/2022, sua intenção, opção esta que surtirá efeito de forma imediata e terá caráter
          irrevogável e irretratável.
        </p>
      </li>
      <li>
        <p class="m-2">
          7. O BENEFICIÁRIO TITULAR assume o compromisso de realizar pontualmente o pagamento do valor da mensalidade,
          por si e por seus dependentes, com vencimento todo 5º dia útil de cada mês, através de débito em conta
          corrente conforme bancos mencionados nesta proposta de adesão ou boleto bancário, desde que devidamente
          autorizado na presente proposta de adesão.
        </p>
      </li>
      <li>
        <p class="m-2">
          8. Caso seja aceita a presente proposta, o BENEFICIÁRIO declara ter conhecimento de que seu ingresso no plano
          contratado será efetivado somente na DATA DE VIGÊNCIA, constante na proposta de adesão, quando inicia-se a
          contagem dos prazos de carências para utilização das coberturas contratuais.
        </p>
      </li>
      <li>
        <p class="m-2">
          9. Afirma o BENEFICIÁRIO TITULAR ter ciência de que na hipótese de impontualidade no pagamento da mensalidade
          serão cobrados juros de mora de 1% (um por cento) ao mês, calculados proporcionalmente ao tempo de atraso,
          além de multa moratória de 2% (dois por cento) incidente sobre o valor do débito atualizado.
        </p>
      </li>
      <li>
        <p class="m-2">
          10. Declara o BENEFICIÁRIO TITULAR possuir completo conhecimento de que os valores das mensalidades serão
          reajustados conforme a sinistralidade apurada, na forma prevista pelo CONTRATO DE PLANO DE SAÚDE ODONTOLÓGICO
          celebrado entre ESTIPULANTE e a CONTRATADA e também prevista no MANUAL DE ORIENTAÇÃO PARA CONTRATAÇÃO DE PLANO
          DE SAÚDE ODONTOLÓGICO.
        </p>
      </li>

      <li>
        <p class="m-2">
          12. Declara o BENEFICIÁRIO TITULAR ter conhecimento de que será excluído do presente contrato em caso de perda
          da elegibilidade e nos casos de inadimplemento, atrasando o pagamento da mensalidade por período igual ou
          superior a 60 (sessenta) dias consecutivos ou não, nos últimos doze meses de vigência, desde que seja
          cientificado até o quinquagésimo dia de inadimplência, oportunidade em que será concedido prazo de 10 (dez)
          dias para regularização do débito, sem prejuízo do direito de lhe ser requerida judicialmente a quitação do
          débito com suas consequências moratórias.
          <br />
          1º: No caso do cancelamento do plano contratado, haverá a exclusão do BENEFICIÁRIO TITULAR e dos BENEFICIÁRIOS
          DEPENDENTES, quando houver, sem prejuízo da cobrança dos valores em aberto com seus respectivos encargos.

          <br />
          2º: O ESTIPULANTE utilizará todos os meios admitidos em direito para satisfação de seu crédito, inclusive
          proceder com a inscrição do BENEFICIÁRIO inadimplente nos órgãos de proteção ao crédito, a seu critério e
          conveniência.
        </p>
      </li>
      <li>
        <p class="m-2">
          13. O BENEFICIÁRIO afirma ter ciência que também será excluído do plano de saúde odontológico em casos de
          fraude, declaração de informações falsas, incompletas ou omissões, como também na hipótese de utilização
          indevida do cartão de identificação, ou seja, se vier a autorizar terceiros a utilizar o seu cartão de
          identificação para realização de quaisquer procedimentos, sem prejuízo do ESTIPULANTE e da CONTRATADA adotarem
          as medidas judiciais cabíveis para se ressarcir dos danos sofridos.
        </p>
      </li>
      <li>
        <p class="m-2">
          14. Declara ainda o BENEFICIÁRIO TITULAR, ter ciência que na hipótese da sua exclusão, todos os seus
          dependentes incluídos no plano de saúde odontológico, serão automaticamente excluídos.
        </p>
      </li>
      <li>
        <p class="m-2">
          15. Declara o BENEFICIÁRIO TITULAR ter conhecimento que a responsabilidade pela prestação dos atendimentos
          ambulatoriais e hospitalares é exclusiva dos profissionais e instituições a serviço da CONTRATADA.
        </p>
      </li>
      <li>
        <p class="m-2">
          16. O BENEFICIÁRIO outorga ao ESTIPULANTE, procuração, para que a mesma possa representá-lo e a seus
          dependentes perante a CONTRATADA e a Agência Nacional de Saúde Suplementar – ANS, no cumprimento das cláusulas
          previstas no CONTRATO DE PLANO DE SAÚDE ODONTOLÓGICO.
        </p>
      </li>
      <li>
        <p class="m-2">
          17. O beneficiário afirma ter ciência que terá acesso ao CARTÃO DE IDENTIFICAÇÃO virtual (do titular e seus
          dependentes) em tempo hábil para usufruto. Caso opte pela CARTÃO DE IDENTIFICAÇÃO físico, o titular deverá
          solicitar pelos meios de comunicação disponibilizados pela Estipulante (telefone ou e-mail). O prazo para
          envio das CARTÃO DE IDENTIFICAÇÃO físicos, serão de até 15 dias úteis, a contar da data de solicitação.
        </p>
      </li>
      <li>
        <p class="m-2">
          18. No caso de exclusão do plano de saúde odontológico, por qualquer motivo, o BENEFICIÁRIO TITULAR fica
          obrigado a devolver ao ESTIPULANTE os cartões de identificação fornecidos pela operadora, de si e de
          dependente(s), sob a pena de responsabilizar-se pela utilização indevida.
        </p>
      </li>
      <li>
        <p class="m-2">
          19. O Beneficiário Titular e/ou Dependente(s) excluído do plano de saúde odontológico, somente poderá ser
          incluído novamente no PLANO DE SAÚDE UNIMED ODONTO desde que não existam débitos pendentes junto à
          ESTIPULANTE, observado o cumprimento de novo período de carência.
        </p>
      </li>
      <li>
        <p class="m-2">
          20. O Beneficiário declara estar ciente do cumprimento de CARÊNCIA para si e seus dependentes, conforme tabela
          abaixo:
        </p>
        <div class="table-responsive">
          <table class="table table-bordered" cellpadding="5" cellspacing="0">
            <thead>
              <tr>
                <th class="text-center" style="background: #ccc">Procedimento de</th>
                <th class="text-center" style="background: #ccc">Prazo Máximo Legal</th>
                <th class="text-center" style="background: #ccc">Prazo Contratado</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">Urgência/Emergência</td>
                <td class="text-center">24 horas</td>
                <td class="text-center">24 horas</td>
              </tr>
              <tr>
                <td class="text-center">Diagnóstico</td>
                <td class="text-center">180 dias</td>
                <td class="text-center">24 horas</td>
              </tr>
              <tr>
                <td class="text-center">Radiologia</td>
                <td class="text-center">180 dias</td>
                <td class="text-center">60 dias</td>
              </tr>
              <tr>
                <td class="text-center">Prevenção em Saúde Bucal</td>
                <td class="text-center">180 dias</td>
                <td class="text-center">60 dias</td>
              </tr>
              <tr>
                <td class="text-center">Dentística</td>
                <td class="text-center">180 dias</td>
                <td class="text-center">60 dias</td>
              </tr>
              <tr>
                <td class="text-center">Cirurgia</td>
                <td class="text-center">180 dias</td>
                <td class="text-center">60 dias</td>
              </tr>
              <tr>
                <td class="text-center">Periodontia</td>
                <td class="text-center">180 dias</td>
                <td class="text-center">90 dias</td>
              </tr>
              <tr>
                <td class="text-center">Endontia</td>
                <td class="text-center">180 dias</td>
                <td class="text-center">90 dias</td>
              </tr>
              <tr>
                <td class="text-center">Ortodontia</td>
                <td class="text-center">180 dias</td>
                <td class="text-center">180 dias</td>
              </tr>
              <tr>
                <td class="text-center">Prótese</td>
                <td class="text-center">180 dias</td>
                <td class="text-center">180 dias</td>
              </tr>
              <tr>
                <td class="text-center">
                  Demais especialidades/procedimentos cobertos, inclusive por atualização do rol de procedimentos
                </td>
                <td class="text-center">180 dias</td>
                <td class="text-center">180 dias</td>
              </tr>
            </tbody>
          </table>
        </div>
      </li>

      <li>
        <p class="m-2">
          21. O prazo de vigência do contrato é de 12 meses, ficando prorrogado automaticamente, caso não haja
          solicitação ou outra causa de cancelamento.
        </p>
      </li>
    </ul>
  </div>
</section>
<!-- informações Importantes -->
<section>
  <div class="documento-aditivo-container espacamento-mobile alinhamento-texto-mobile">
    <h3 class="titulo text-center bold-preto-700 mb-1 p-1" style="background: #ccc; border-radius: 10px">
      DECLARAÇÕES COMPLEMENTARES DO BENEFICIÁRIO
    </h3>
    <p>Declaro que:</p>
    <ul>
      <li>
        <p class="m-2">
          a. Recebi o MANUAL DE ORIENTAÇÃO PARA CONTRATAÇÃO DE PLANOS DE SAÚDE ODONTOLÓGICO (MPS), editado pela Agência
          Nacional de Saúde Suplementar - ANS, antes da assinatura da presente proposta li e compreendi o seu inteiro
          teor.
        </p>
      </li>
      <li>
        <p class="m-2">
          b. Li o teor da PROPOSTA DE ADESÃO AO PLANO DE SAÚDE ODONTOLÓGICO COLETIVO POR ADESÃO, estipulado pela Géia
          Administradora de Benefícios, compreendi adequadamente todos os seus termos, não restando qualquer dúvida
          quanto ao alcance e ao conteúdo das suas cláusulas. E, por assim se encontrar certo e acordado, firmo por
          livre e espontânea vontade a presente PROPOSTA DE ADESÃO, em duas vias de igual teor e forma.
        </p>
      </li>
    </ul>
    <div class="doc-footer border mb-5" style="border-radius: 10px; padding: 0.5rem">
      <!-- <p class="bold">Assinatura do beneficiário titular:</p>
      <p>
        Assinatura via área logada pelo beneficiário {{ nomeTitular }} em {{ dataHoraAssinaturaAreaLogada }},
        comercialização através da corretora {{ nomeCorretora }} e vendedor {{ nomeVendedor }}, conforme Art. 7º da RN
        413
      </p>
      <p>Data de preenchimento da proposta: {{ dataPreenchimentoProposta }}</p> -->

      <app-assinatura-documento
        [nomeTitular]="nomeTitular"
        [dataAssinatura]="dataHoraAssinaturaAreaLogada"
        [horaAssinatura]=""
        [nomeCorretora]="nomeCorretora"
        [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
    </div>
  </div>

  <!-- Email Declinio Proposta -->
  <section *ngIf="statusProposta">
    <app-emails-declinio-proposta
      [tipoPropostaDeclinada]="tipoDeclinio"
      [dataDeclinio]="dataDeclinio"
      [horaDeclinio]="horaDeclinio"
      [motivoDeclinio]="motivoDeclinio"
      [nomeTitular]="nomeTitular"
      [codigoProposta]="codigoProposta"
      [motivoDeclinio]="motivoDeclinio"></app-emails-declinio-proposta>
  </section>

  <!-- formulario de inscricao de entidade -->
  <ng-container
    *ngIf="
      (entidadeProposta == 'ADSERVIP' || entidadeProposta == 'ABJE') &&
      !this.dadosOperadoraCabecalho.ehInclusaoDependente
    ">
    <section *ngIf="existeFormularioEntidade && !dadosProstaCompletos?.externalRegistrationLink">
      <app-header-documento-final-proposta
        [entidadeProposta]="entidadeProposta"
        [razaoSocialEntidade]="razaoSocialEntidade"
        [codigoProposta]="codigoProposta"
        [vigenciaProposta]="vigenciaProposta"
        [operadoraVM]="operadoraVM"
        [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
      <app-formulario-inscricao-entidade-adservip
        [formEntidadeSomenteLeitura]="true"
        [retornoDadosFormularioEntidade]="retornoDadosFormularioEntidade"></app-formulario-inscricao-entidade-adservip>
      <app-formulario-inscricao-entidade-abje
        *ngIf="this.entidadeProposta === 'ABJE'"
        [formEntidadeSomenteLeitura]="true"
        [retornoDadosFormularioEntidade]="retornoDadosFormularioEntidade"
        [logoEntidade]="null"
        [nomeEntidade]="entidadeProposta"></app-formulario-inscricao-entidade-abje>

      <app-assinatura-documento
        [nomeTitular]="nomeTitular"
        [dataAssinatura]="dataAssinaturaDadosBancarios"
        [horaAssinatura]="horaAssinaturaDadosBancarios"
        [nomeCorretora]="nomeCorretora"
        [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
    </section>
  </ng-container>

  <!-- Documentos Beneficiário -->
  <section>
    <div class="nova-pagina">
      <app-lista-documentos-proposta
        [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"
        [dadosOperadoraDM]="dadosOperadoraDM"
        [razaoSocialEntidade]="razaoSocialEntidade"
        [entidadeProposta]="entidadeProposta"
        [codigoProposta]="codigoProposta"
        [vigenciaProposta]="vigenciaProposta"
        [beneficiariosComDocumentos]="beneficiariosComDocumentos"></app-lista-documentos-proposta>
    </div>
  </section>
</section>
